var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBookOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2002 7.8562C11.2002 7.12686 11.4899 6.42738 12.0057 5.91166C12.5214 5.39593 13.2208 5.1062 13.9502 5.1062H19.4502C19.6325 5.1062 19.8074 5.17863 19.9363 5.30757C20.0653 5.4365 20.1377 5.61136 20.1377 5.7937V16.7937C20.1377 16.976 20.0653 17.1509 19.9363 17.2798C19.8074 17.4088 19.6325 17.4812 19.4502 17.4812H13.9502C13.2208 17.4812 12.5214 17.7709 12.0057 18.2867C11.4899 18.8024 11.2002 19.5019 11.2002 20.2312",
    stroke: "#677791",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.2627 16.7937C2.2627 16.976 2.33513 17.1509 2.46406 17.2798C2.59299 17.4088 2.76786 17.4812 2.9502 17.4812H8.4502C9.17954 17.4812 9.87901 17.7709 10.3947 18.2867C10.9105 18.8024 11.2002 19.5019 11.2002 20.2312V7.8562C11.2002 7.12686 10.9105 6.42738 10.3947 5.91166C9.87901 5.39593 9.17954 5.1062 8.4502 5.1062H2.9502C2.76786 5.1062 2.59299 5.17863 2.46406 5.30757C2.33513 5.4365 2.2627 5.61136 2.2627 5.7937V16.7937Z",
    stroke: "#677791",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookOpen);
export default __webpack_public_path__ + "static/media/BookOpen.f5bb54178f0d6c0251c2152877b40ed5.svg";
export { ForwardRef as ReactComponent };